import {notifyException} from 'utilities/analytics/bugsnag';
import {EVENTS} from 'global-constants';

const Selectors = {
  DATA_SET_COOKIE: '[data-set-cookie]',
  DATA_DELETE_COOKIE: '[data-delete-cookie]',
};

const Attrs = {
  DATA_SET_COOKIE: 'setCookie',
  DATA_DELETE_COOKIE: 'deleteCookie',
};

export function initDataCookies() {
  [...document.querySelectorAll(Selectors.DATA_SET_COOKIE)].forEach(element => {
    element.addEventListener(EVENTS.click, onSetCookieClick);
  });

  [...document.querySelectorAll(Selectors.DATA_DELETE_COOKIE)].forEach(
    element => {
      element.addEventListener(EVENTS.click, onDeleteCookieClick);
    }
  );
}

function onSetCookieClick(evt) {
  const {target} = evt;

  try {
    const cookieData = JSON.parse(target.dataset[Attrs.DATA_SET_COOKIE]);
    setCookie(cookieData);
  } catch (error) {
    notifyException({error, errorName: 'SetDataCookie Failed'});
  }
}

function onDeleteCookieClick(evt) {
  const {target} = evt;

  try {
    const cookieData = JSON.parse(target.dataset[Attrs.DATA_DELETE_COOKIE]);
    deleteCookie(cookieData);
  } catch (error) {
    notifyException({error, errorName: 'DeleteDataCookie Failed'});
  }
}

export function setCookie({name, value = '', expires, path = '/'}) {
  document.cookie = `${name}=${value}${formatExpiry(expires)}; path=${path}`;
}

export function deleteCookie({name, path = '/'}) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=${path}`;
}

function formatExpiry(expires) {
  if (!expires) return '';

  const date = new Date();
  date.setTime(date.getTime() + expires);

  return `; expires=${date.toUTCString()}`;
}

export function getCookieValue(key) {
  const cookieString = document.cookie.match(
    `(^|[^;]+)\\s*${key}\\s*=\\s*([^;]+)`
  );
  return cookieString ? cookieString.pop() : undefined;
}
